import { Skeleton } from "@chakra-ui/react";
import * as GQL from "src/types/graphql";
import { GenericError } from "../Feedback/GenericError";
import { RemoteDataView } from "../Layout/RemoteDataView";
import { useFormTemplates } from "../Providers/FormTemplateProvider";
import { NavFormItem } from "./NavFormItem";

interface NavFormsListProps {
  organization: GQL.Organization;
}

export function NavFormsList({ organization }: NavFormsListProps) {
  const { navFormTemplates } = useFormTemplates();

  return (
    <RemoteDataView
      remoteData={navFormTemplates}
      error={() => <GenericError />}
      loading={<Skeleton width="16rem" height="2.25rem" />}
    >
      {(data) => (
        <>
          {data.map((formTemplate) => (
            <NavFormItem
              key={formTemplate.id}
              organization={organization}
              formTemplate={formTemplate}
            />
          ))}
        </>
      )}
    </RemoteDataView>
  );
}
